import { render, staticRenderFns } from "./custom-tag-select.vue?vue&type=template&id=3700ca30&scoped=true&"
import script from "./custom-tag-select.vue?vue&type=script&lang=js&"
export * from "./custom-tag-select.vue?vue&type=script&lang=js&"
import style0 from "./custom-tag-select.vue?vue&type=style&index=0&id=3700ca30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3700ca30",
  null
  
)

export default component.exports